import { SERVER_URL } from 'utils/config';

const LoginPage = () => {
  window.location.href = `${SERVER_URL}/login?admin_signin=true`;
  return null;
};

export default LoginPage;
